<template>
  <div class="page_container warehousingRecordPage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >SKU管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>库存操作记录追溯</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="main_container">
      <div class="operation_wrap flex-rowr">
        <div class="select_add flex-rowl"></div>
        <div class="filter flex-rowr">
          <div class="search_wrap flex-between">
            <el-input
              v-model="searchTxt"
              placeholder="输入SKU编码/ISBN编码查找匹配商品"
              @keyup.enter.native="handleSearch(1)"
            ></el-input>
            <div class="search_btn flex-rowc" @click="handleSearch(1)">
              <i class="iconfont icon-chazhaotubiao"></i>
            </div>
          </div>
          <div class="search_wrap flex-between">
            <el-date-picker
              v-model="dataValue"
              type="date"
              alue-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
            <div class="search_btn flex-rowc" @click="handleSearch(2)">
              <i class="iconfont icon-chazhaotubiao"></i>
            </div>
          </div>
          
        </div>
        <div class="sort_wrap flex-rowc" @click="handleRest">
            <span>重置显示库存记录列表</span>
            <i class="iconfont icon-shuaxin"></i>
          </div>
      </div>
      <div
        class="list_wrap"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
      >
        <template v-if="dataList.length > 0">
          <div class="item_wrap" v-for="item in dataList" :key="item.id">
            <div class="item_main_wrap flex-rowl">
              <div class="content_wrap flex-between">
                <div class="intro_box flex-rowl"  @click="handleDetail(item)">
                  <div class="block">
                    <h1>商品名称：</h1>
                    <p>
                      <span>{{ item.cm ? item.cm.commodityname : "" }}</span>
                    </p>
                    <!-- <p>
                      <span>{{ item.cm ? item.cm.commodityname_e : "" }}</span>
                    </p>
                    <p>
                      <span>{{ item.cm ? item.cm.commodityname_y : "" }}</span>
                    </p>
                    <p>
                      <span>{{ item.cm ? item.cm.commodityname_m : "" }}</span>
                    </p>
                    <p>
                      <span>{{ item.cm ? item.cm.commodityname_t : "" }}</span>
                    </p> -->
                  </div>
                  <div class="block">
                    <p>
                      入库数量：<span>{{ item.num }}</span>
                    </p>
                    <p>
                      商品ID：<span>{{ item.cm ? item.cm.id : "" }}</span>
                    </p>
                    <p>
                      SKU采购编码：<span>{{ item.cm ? item.cm.sku : "" }}</span>
                    </p>
                    <!-- <p>
                      ISBN编码：<span>{{ item.cm ? item.cm.ISBN : "" }}</span>
                    </p> -->
                    <!-- <p>
                      是否精品推荐：<span>{{ item.isintro }}</span>
                    </p> -->
                  </div>
                  <div class="block">
                    <p>
                      操作日期：<span>{{ item.createdate | formatDate }}</span>
                    </p>
                    <p>
                      操作人员：<span>{{ item.userman }}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="edit_group flex-rowr">
                <div class="detail_icon" @click="handleDetail(item)">
                  <i class="iconfont icon-details"></i>
                </div>
              </div>
            </div>
          </div>
        </template>
        <el-empty
          description="暂无入库记录"
          v-if="!loading && dataList.length == 0"
        ></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import { queryShopWareRecord } from "../../api/api";
import storage from "../../utils/storage";

export default {
  name: "wRecordIndex",
  data() {
    return {
      loading: false,
      dataValue: "",
      datestr: "",
      searchTxt: "",
      dataList: [],
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      }else {
        return date
      }
    },
  },
  created() {
    this.initData();
    console.log(this.$store.state.USERINFO.qy.qyguid);
  },
  methods: {
    // 重置商品
    handleRest() {
      this.searchTxt = ''
      this.datestr = ''
      this.dataValue = ''
      this.initData()
    },
    initData() {
      this.loading = true;
      queryShopWareRecord({
        keyword: this.searchTxt,
        datestr: this.datestr,
        qyguid: this.$store.state.USERINFO.qy.qyguid,
      }).then((res) => {
        if(res.status) {
            this.loading = false;
          return
        }
        this.dataList = res;
        this.loading = false;
      });
    },

    handleDetail(item) {
      storage.set("DETAILITEM", item);
      this.$router.push("/recordIndex/wRecordDetail");
    },
    handleSearch(type) {
      if (type == 2) {
        if (this.dataValue) {
          let date = this.dataValue;
          this.datestr =
            date.getFullYear() +
            "-" +
            (date.getMonth() + 1) +
            "-" +
            date.getDate();
        }else {
          this.dataValue = ''
          this.datestr = ''
        }
      }

      this.initData();
    },
    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.warehousingRecordPage {
  .operation_wrap {
    .search_wrap {
      width: 310px;
      &:last-child {
        width: 220px;
        margin-left: 20px;
      }
    }
  }

  .list_wrap {
    height: 58vh;
    .item_main_wrap {
      align-items: center;
    }
    .intro_box {
      cursor: pointer;
    }
    .edit_group {
      .detail_icon {
        cursor: pointer;
        .iconfont {
          color: #838383;
          font-size: 30px;
        }
      }
    }
  }
}
</style>